module.exports = __webpack_public_path__ + "img/voice.2b303c49.svg";